import { Observable } from 'rxjs';
import { ofType } from 'redux-observable';
import { mergeMap } from 'rxjs/operators';
import * as search from '@webapp/sdk/search';
import { Actions } from '../../actions';
import {
  SearchUsers,
  SearchUsersSuccess,
  SearchUsersError,
} from '../action-creators';
import { SEARCH_USERS } from '../actions';
import SimpleUser from '@common/types/user/simple-user';
import { TracInvite } from '@services/invites/types/trac-invite';

export const searchUsersEpic = (action$: Observable<Actions>) =>
  action$.pipe(
    ofType<Actions, SearchUsers>(SEARCH_USERS),
    mergeMap(async (action) => {
      try {
        const [usersResponse, invitesResponse] = await Promise.all([
          search.users(action.query),
          search.invites(action.query, 'user'),
        ]);

        const usersList: SimpleUser[] = usersResponse.hits.hits.map(
          (r: any) => r._source
        );
        const invitesList: TracInvite[] = invitesResponse.hits.hits.map(
          (r: any) => r._source
        );

        return new SearchUsersSuccess(usersList, invitesList);
      } catch (err) {
        return new SearchUsersError(err.message);
      }
    })
  );
